import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { BsModalAlertComponent, createAlertModalOptions } from '../../core/modal/modal-alert.component';
import { TicketModel } from '../types/ticket.model';

@Injectable({
  providedIn: 'root'
})

export class SupportService {

  constructor(public http: HttpClient,
              private modalService: BsModalService) {}

  sendMessage(ticket: TicketModel): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'json/text'
    });
    // The servlet has been removed since this should no longer be used after moving form to ZOHO
    return this.http.post<HttpResponse<any>>('servlets/support/', {...ticket}, {observe: 'response', headers})
             .pipe(
                map((res: HttpResponse<any>) => {
                  if (res.ok) {
                    this.modalService
                      .show(BsModalAlertComponent, createAlertModalOptions('Success',
                        'Your message has been sent to our support. ' +
                          'You\'ll receive an email with ticket ID and we\'ll get back to you soon.'
                      ));
                  }
                })
              );
  }

}
